import { z } from 'zod'

// エージェントとのチャットのセッション。salescore-agent-storage の DESIGN.md の「インターフェース」の、セッションの項目のうち画面に返すもの。
// storage が返すほかの項目（updatedAt、status など）は、画面で使うときに足す。スキーマにない項目は BE が取り除く
export const agentSessionSchema = z.object({
  // storage が振る小文字の UUIDv7。辞書順が作成順になる
  id: z.string(),
  // 最初のターンで runtime が付けるまでは null
  title: z.string().nullable(),
  // 作成日時。storage が ISO 8601 の文字列で返す
  createdAt: z.string(),
  // 削除を始めた日時（ISO 8601）。削除が途中で失敗して一覧に残っている、削除中のセッションだけが持つ。
  // 画面は削除中のセッションを開かせず、同じ ID で削除を再試行させる
  deletingAt: z.string().optional(),
})
